<template>
	<v-container class="py-md-10 cards" :class="coachEffectClass" :key="$store.state.calculatorRerender">
	    <v-row>
	    	<template v-for="layer in allLayers">
				<Card 
					v-for="card in featuredCards(layer.cards)" 
					:card="card"
					:layer="layer"
					:key="card.id"
					:featured="true"
				/>
	    	</template>

	    	<template v-for="layer in layers">
				<Card 
					v-for="card in cards(layer.cards)" 
					:card="card" 
					:layer="layer" 
					:key="card.id" 
				/>
	    	</template>
	    </v-row>
	</v-container>
</template>

<script>
import Card from '@/components/Card.vue'

export default {
	components: {Card},

	methods: {
		cards(cards) {
			return cards.filter(c => {
				return ! c.hidden
					&& ! c.isFeatured
					&& ! c.type.includes('coach')
					&& ! c.type.includes('prestep')
					&& ! c.type.includes('menu_bottom_banner')
					&& ( ! c.lang || c.lang === this.$store.state.endUser.language)
			}) 
		},

		featuredCards(cards) {
			return cards.filter(c => {
				return ! c.hidden
					&& c.isFeatured
					&& ! c.type.includes('coach')
					&& ! c.type.includes('prestep')
					&& ! c.type.includes('menu_bottom_banner')
					&& ( ! c.lang || c.lang === this.$store.state.endUser.language)
			})
		},
	},

	computed: {
		coachEffectClass() {
		    return this.$store.state.coachEffect
		},

		layers() {
			// Just to make it reactive (to change)
			let endUserLanguage = this.$store.state.endUser.language

			return this.$store.state.layers
				.filter(l => l.active && ! l.hidden)
		},

		allLayers() {
			// Just to make it reactive (to change)
			let endUserLanguage = this.$store.state.endUser.language

			return this.$store.state.layers	
				.filter(l => ! l.hidden)
		}
	}	
}
</script>